const actions = {
    async nextUserPosts({commit, state}, userId) {
        return state.socialService.userPosts(userId)
            .then(({posts, users}) => {
                if (posts.length) commit("setUserPosts", posts);
                if (users.length) commit("setUsers", users);
            })
            .catch(error => {
                commit("setErrors", {"nextUserPostsError": error.message});
                return Promise.reject(error);
            });
    },
    async userProfile({state, commit}, userId) {
        return state.socialService.user(userId)
            .then(userInfo => {
                commit("setUsers", [userInfo]);
                return userInfo;
            })
            .catch(error => {
                commit("setErrors", {"userProfileError": error.message});
                return Promise.reject(error);
            });
    },
    async updateProfile({state, commit}) {
        let oldProfile = state.allUsersProfile[state.activeUserId];
        let eliteFitUserInfo = state.eliteFitUserInfo;
        let updateProfile = {};

        let eliteFitName = eliteFitUserInfo.name;
        if (eliteFitName) { // update fullName
            // Regular expression pattern to match only letters and spaces
            const regex = /[a-zA-Z\s]+/g;
            // Join all matches
            let fullName = eliteFitName.match(regex).join('');
            // Remove leading and trailing white spaces
            fullName = fullName.trim();
            if (fullName !== oldProfile.fullName)
                updateProfile.fullName = fullName;

        }
        let eliteFitEmail = eliteFitUserInfo.email;
        if (eliteFitEmail) { // update userName
            // If no "@" symbol is found, return the entire email as the username
            const atIndex = eliteFitEmail.indexOf('@');
            let username = eliteFitEmail;
            if (atIndex !== -1)
                username = eliteFitEmail.substring(0, atIndex);
            if (username !== oldProfile.userName)
                updateProfile.userName = username;
        }

        if (Object.keys(updateProfile).length === 0) return;

        updateProfile = Object.assign({}, oldProfile, updateProfile);
        return state.socialService.updateProfile(updateProfile)
            .then(updatedProfile => {
                commit("setSocialUserInfo", updatedProfile);
                return updatedProfile;
            })
            .catch(error => {
                commit("setErrors", {"updateProfileError": error.message});
                return Promise.reject(error);
            });
    },
    async editProfile({state, commit}, editedProfile) {
        let oldProfile = state.allUsersProfile[state.activeUserId];
        let updateProfile = {};
        if (editedProfile.userName !== oldProfile.userName)
            updateProfile.userName = editedProfile.userName;
        if (editedProfile.profileImageUrl !== oldProfile.profileImageUrl)
            updateProfile.profileImageUrl = editedProfile.profileImageUrl;
        if (editedProfile.description !== oldProfile.description)
            updateProfile.description = editedProfile.description;

        if (Object.keys(updateProfile).length === 0) return;

        updateProfile = Object.assign({}, oldProfile, updateProfile);
        return state.socialService.updateProfile(updateProfile)
            .then(updatedProfile => {
                commit("setSocialUserInfo", updatedProfile);
                return updatedProfile;
            })
            .catch(error => {
                commit("setErrors", {"updateProfileError": error.message});
                return Promise.reject(error);
            });
    },
    async followUser({state, commit}, userId) {
        return state.socialService.followUser(userId)
            .then(_ => commit("setFollowing", {userId, isFollow: true}))
            .catch(error => {
                commit("setErrors", {"followUserError": error.message});
                return Promise.reject(error);
            });
    },
    async unFollowUser({state, commit}, userId) {
        return state.socialService.unFollowUser(userId)
            .then(_ => commit("setFollowing", {userId, isFollow: false}))
            .catch(error => {
                commit("setErrors", {"unfollowUserError": error.message});
                return Promise.reject(error);
            });
    },
    async blockUser({state, commit}, userId) {
        return state.socialService.blockUser(userId)
            .then(_ => commit("setBlocked", {userId, isBlocked: true}))
            .catch(error => {
                commit("setErrors", {"blockUserError": error.message});
                return Promise.reject(error);
            });
    },
    async unBlockUser({state, commit}, userId) {
        return state.socialService.unBlockUser(userId)
            .then(_ => commit("setBlocked", {userId, isBlocked: false}))
            .catch(error => {
                commit("setErrors", {"unBlockUserError": error.message});
                return Promise.reject(error);
            });
    },
    async reportUser({state, commit}, {userId, reason}) {
        return state.socialService.reportUser(userId, reason, state.activeUserId)
            .then(res => console.log("reportedUser: ", res))
            .catch(error => {
                commit("setErrors", {"reportUserError": error.message});
                return Promise.reject(error);
            });
    },
};

export default {
    actions
}